import ApiService from "../ApiService";

const pendingReasonsService = {
    create(reason) {
        return ApiService.post(`/pending-reason`, reason);
    },

    getPendings() {
        return ApiService.get(`/pending-reason`);
    },
    updatePendingReason(id, data) {
        return ApiService.post(`/pending-reason/update?id=${id}`, data);
    },
    deletePendingReason(data) {
        return ApiService.post(`/pending-reason/remove`, data);
    }
};

export default pendingReasonsService;
